import React, { useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import EditPartnerAccountForm from './EditPartnerAccountForm'
import FormDrawerWrapper from '../../../../../features/components/FormDrawerWrapper'
import SkeletonSingleSectionForm from '../../../../../features/components/FormDrawerWrapper/Skeletons/SkeletonSingleSectionForm'

import useManageDrawer from '../../../../../hooks/formHooks/useManageDrawer'
import useManageEditFormData from '../../../../../hooks/formHooks/useManageEditFormData'

import { selfAccountSelector, selfAccountWasLoadedSelector } from '../../../../../modules/selectors/selfAccounts'
import { clearSelfAccount, getSelfAccount } from '../../../../../modules/actions/selfAccounts'

import { PARTNER_ACCOUNT_EDIT } from '../../../../../constants/forms'

const EditPartnerAccount = () => {
  const dispatch = useDispatch()
  const selfAccount = useSelector(selfAccountSelector)
  const selfAccountWasLoaded = useSelector(selfAccountWasLoadedSelector)

  const { selectedEditItemId } = useManageDrawer({ formName: PARTNER_ACCOUNT_EDIT })

  const getDataHandler = useCallback(() => {
    dispatch(getSelfAccount(selectedEditItemId))
  }, [dispatch, selectedEditItemId])

  const clearItemDataHandler = useCallback(() => {
    dispatch(clearSelfAccount())
  }, [dispatch])

  useManageEditFormData({
    formName: PARTNER_ACCOUNT_EDIT,
    loadedDataId: selfAccount.id,
    getDataHandler: getDataHandler,
    clearDataHandler: clearItemDataHandler
  })

  return (
    <FormDrawerWrapper
      formName={PARTNER_ACCOUNT_EDIT}
      title="Edit a partner account"
      showOpenButton={false}
      isFormLoading={!selfAccountWasLoaded}
      SkeletonFormComponent={SkeletonSingleSectionForm}
    >
      <EditPartnerAccountForm />
    </FormDrawerWrapper>
  )
}

export default EditPartnerAccount
